<style>
@import "@/assets/css/custom.css";
</style>

<template>
	<div>
		<Breadcrumbs main="Accounts" :title="pageTitle" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
								<div class="fw-bold">
									Vendor: <span class="text-primary">{{ vendorName }}</span>
								</div>
								<router-link :to="{ name: 'vendor_credits' }" class="btn btn-light">Back</router-link>
							</div>

							<div class="col-md-12 project-list filter-sort mt-3">
								<div class="row align-items-end">
									<div class="col-md-6 d-flex mt-2">
										<label class="d-flex listing-length ms-1 align-items-center">
											<span>Show</span>
											<select class="form-select mx-2" style="width: auto" v-model="listing_length" @change="fetchVendorInvoices()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>

									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchVendorInvoices()">
											<option value="">All</option>
											<option value="1">Pending</option>
											<option value="2">Paid</option>
										</select>
									</div>

									<div class="col-md-4 mt-2">
										<input
											type="text"
											class="form-control"
											placeholder="Search invoice number…"
											v-model="keyword"
											@keyup="fetchVendorInvoices()"
										/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table mt-3">
								<table class="display table">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th class="text-start">Invoice #</th>
											<th>Invoice Date</th>
											<th>Amount</th>
											<th>Boards</th>
											<th>Total Boards</th>
											<th>Status</th>
											<th>Updated</th>
										</tr>
									</thead>
									<tbody v-if="rows.length">
										<tr align="center" v-for="(row, index) in rows" :key="row.id">
											<td>{{ from != null ? from + index : index + 1 }}</td>
											<td class="text-start">{{ row.invoice_number || "—" }}</td>
											<td>{{ row.invoice_date ? $filters.formatDate(row.invoice_date) : "—" }}</td>
											<td class="fw-bold">₹{{ formatMoney(row.amount) }}</td>
											<td>
												<span v-if="row.board_number_start && row.board_number_end">
													{{ row.board_number_start }} - {{ row.board_number_end }}
												</span>
												<span v-else>—</span>
											</td>
											<td>{{ row.total_boards ?? "—" }}</td>
											<td>
												<span v-if="row.payment_status == 1" class="badge rounded-pill bg-warning text-dark">Pending</span>
												<span v-else-if="row.payment_status == 2" class="badge rounded-pill bg-success">Paid</span>
												<span v-else class="badge rounded-pill bg-light text-dark">—</span>
											</td>
											<td>{{ row.updated_at ? $filters.formatDate(row.updated_at) : "—" }}</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="8" align="center">No vendor invoices found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="rows.length" class="float-start mt-2 d-block">
								Showing {{ from }} to {{ to }} of {{ total }} entries
							</caption>
							<nav v-if="rows.length && pagination.length" aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination mb-0">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="'p-' + index + '-' + page.label"
									>
										<a class="page-link" href="#" @click.prevent="onPageClick(page)" tabindex="-1">
											<span v-if="index === 0">Prev</span>
											<span v-else-if="index === pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VendorInvoices",
	data() {
		return {
			token: "",
			keyword: "",
			status: "",
			listing_length: 10,
			rows: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: "",
		};
	},
	computed: {
		vendorId() {
			return this.$route.params.id || "";
		},
		vendorName() {
			return this.$route.query.vendor_name || this.rows?.[0]?.vendor_name || "—";
		},
		pageTitle() {
			return "Vendor Invoices";
		},
	},
	created() {
		this.fetchVendorInvoices();
	},
	watch: {
		"$route.params.id"() {
			this.fetchVendorInvoices();
		},
	},
	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		listUrl() {
			return `/staffs/vendorInvoices?limit=${this.listing_length}&keyword=${encodeURIComponent(this.keyword || "")}&vendor_id=${this.vendorId}&status=${encodeURIComponent(
				this.status || ""
			)}`;
		},

		fetchVendorInvoices(pageUrl) {
			if (!this.vendorId) {
				this.rows = [];
				this.pagination = [];
				this.from = 0;
				this.to = 0;
				this.total = 0;
				return;
			}

			this.getToken();
			const url = pageUrl || this.listUrl();
			this.active_page_url = url;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					if (res.data.status !== "true" && res.data.status !== true) {
						this.rows = [];
						this.pagination = [];
						return;
					}
					const paginator = res.data.data?.vendorInvoices;
					this.rows = paginator?.data || [];
					this.pagination = paginator?.links || [];
					this.from = paginator?.from ?? 0;
					this.to = paginator?.to ?? 0;
					this.total = paginator?.total ?? 0;
				})
				.catch((err) => {
					console.error(err);
					this.$swal("Error", err.response?.data?.message || "Failed to load vendor invoices", "error");
					this.rows = [];
					this.pagination = [];
				});
		},

		onPageClick(page) {
			if (!page.url) return;
			const base = page.url;
			const sep = base.includes("?") ? "&" : "?";
			this.fetchVendorInvoices(
				`${base}${sep}limit=${this.listing_length}&keyword=${encodeURIComponent(this.keyword || "")}&vendor_id=${this.vendorId}&status=${encodeURIComponent(this.status || "")}`
			);
		},

		formatMoney(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "0.00";
			return n.toFixed(2);
		},
	},
};
</script>

